import React from 'react';

import classnames from 'classnames';

import { ProductType } from '../../types/apiEnums';
import { ImagePresentational } from '../../types/common';
import { Link, LinkType } from '../Link/Link';
import { Typography } from '../Typography/Typography';
import styles from './TinyProductCard.module.css';

export type Props = {
  cardImage: ImagePresentational | null;
  onClick?: React.MouseEventHandler;
  path: string | null;
  productType?: ProductType;
  title: string;
};

export const TinyProductCard = React.memo(({ title, cardImage, path, onClick }: Props) => {
  return (
    <Link
      type={LinkType.Href}
      to={path ?? '/'}
      className={classnames(styles.tinyProductCard)}
      onClick={onClick}
    >
      <>
        <Typography variant='h4' className={styles.title}>{title}</Typography>
        <div
          className={styles.cardContainer}
          style={{
            backgroundImage: `url("${cardImage?.url.href}")`,
          }}
        />
      </>
    </Link>
  );
});

TinyProductCard.displayName = 'TinyProductCard';
